var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 219,
    viewBox: "0 0 301 219",
    width: 301,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.5.409h300v218.182h-300z",
    fill: "#ef2b2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.318.409h54.545v218.182h-54.545z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.5 82.227h300v54.545h-300z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#002868"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m95.955.409h27.273v218.182h-27.273z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.5 95.863h300v27.273h-300z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFlag);
export default __webpack_public_path__ + "static/media/no-flag.630b3575293f54d274ebad80015592f5.svg";
export { ForwardRef as ReactComponent };